import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

class LLBonusWildSubstituteSupplement implements DataProcessorSupplement {
    public process(record: Record): void {
        if (record && record instanceof SpinRecord) {
            const wildBonusResult = record.getResultsOfType(LLWildSymbolResult).pop();

            if (wildBonusResult) {
                wildBonusResult.positions.forEach((wildPosition) => {
                    record.grid[wildPosition.x][wildPosition.y] = `WW_BN`;
                });
            }
        }
    }
}

export default new LLBonusWildSubstituteSupplement();
